import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CCard,
  CCardTitle,
  CFormCheck,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import DynamicInputs from './DynamicInputs'
import './MIPSCard.scss'

const MIPSCard = ({ mipsValueData, setMipsValueData, startAccordionClosed }) => {
  const unfinishedMips = mipsValueData?.filter((mip) => !mip.value)?.length || 0
  const isValid = unfinishedMips === 0
  const [activeItemKey, setActiveItemKey] = useState(startAccordionClosed ? -1 : 0)

  const onMIPSValueChange = (value, index) => {
    let tempList = [...mipsValueData]
    tempList[index] = { ...tempList[index], value }
    setMipsValueData(tempList)
    setActiveItemKey(index + 1 < mipsValueData.length ? index + 1 : -1)
  }

  const clearValue = (index) => {
    let newList = [...mipsValueData]
    newList[index] = { ...newList[index], value: undefined }
    setMipsValueData(newList)
  }

  return (
    <CCard className="MIPSCard">
      <div className="MIPSHeaderContainer">
        <div className="MIPSCardHeader">
          {isValid ? (
            <span className="encounter-progress-circle">
              <i className="fa-light fa-check"></i>
            </span>
          ) : (
            <span className="encounter-progress-number nonactive-number-progress-encounter">
              {mipsValueData.length}
            </span>
          )}
          <CCardTitle className="MIPSCardTitle">MIPS</CCardTitle>
        </div>
        <div className="left-holder">
          {isValid && <span className="completed-container completed-text">COMPLETED</span>}
        </div>
      </div>
      <div className="mips-card-body">
        {mipsValueData?.length > 0 ? (
          <CAccordion key={String(activeItemKey ?? -1)} activeItemKey={activeItemKey ?? -1}>
            {mipsValueData?.map((mip, mipsIndex) => (
              <CAccordionItem itemKey={mipsIndex} key={mip.label}>
                <CAccordionHeader
                  onClick={() =>
                    setActiveItemKey((prev) => {
                      if (prev === mipsIndex) {
                        return -1
                      } else {
                        return mipsIndex
                      }
                    })
                  }
                >
                  <div className="mips-title-holder">
                    <div className="txt-holder">{mip?.label}</div>
                    <div className="left-holder">
                      <div className="thumb-holder">
                        {mip?.value && (
                          <>
                            {mip?.value?.tip?.includes('&#x1f44d;') ? (
                              <div className="unicode-icon green">
                                <i className="fa-regular fa-circle-check"></i>
                              </div>
                            ) : mip?.value?.tip?.includes('&#x1f44e;') ? (
                              <div className="unicode-icon red">
                                <i className="fa-regular fa-triangle-exclamation"></i>
                              </div>
                            ) : (
                              <div
                                className="unicode-icon"
                                dangerouslySetInnerHTML={{ __html: mip?.value?.tip }}
                              />
                            )}
                          </>
                        )}
                      </div>
                      <div className="mips-action">
                        {mip?.value && (
                          <div
                            className="btn btn-secondary"
                            onClick={(e) => {
                              e.stopPropagation()
                              clearValue(mipsIndex)
                            }}
                          >
                            Clear
                          </div>
                        )}
                      </div>
                      {activeItemKey === mipsIndex ? (
                        <i className="fa-solid fa-chevron-up"></i>
                      ) : (
                        <i className="fa-solid fa-chevron-down"></i>
                      )}
                    </div>
                  </div>
                </CAccordionHeader>
                <CAccordionBody>
                  <div className="radio-group-hold">
                    {mip?.options?.map((option, index) => (
                      <div className="input-group-holder" key={index + option?.value}>
                        <div className="radio-holder">
                          <CFormCheck
                            type="radio"
                            name={mip?.label + mipsIndex}
                            id={option?.label + ' ' + mip?.label}
                            label={option?.label}
                            value={option?.value}
                            onChange={(e) =>
                              e.currentTarget.checked
                                ? onMIPSValueChange(option, mipsIndex)
                                : undefined
                            }
                            checked={mip?.value?.value === option?.value}
                          />
                          {option?.tip?.includes('&#x1f44d;') ? (
                            <div className="unicode-icon green">
                              <i className="fa-regular fa-circle-check"></i>
                            </div>
                          ) : option?.tip?.includes('&#x1f44e;') ? (
                            <div className="unicode-icon red">
                              <i className="fa-regular fa-triangle-exclamation"></i>
                            </div>
                          ) : (
                            <div
                              className="unicode-icon"
                              dangerouslySetInnerHTML={{ __html: option?.tip }}
                            />
                          )}
                        </div>
                        {option?.inputs && mip?.value?.label === option?.label && (
                          <div className="input-holder">
                            {option?.inputs?.map((input, index) => (
                              <DynamicInputs
                                input={input}
                                key={index}
                                onChange={(data) => onMIPSValueChange(data, mipsIndex)}
                                index={index}
                                option={option}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </CAccordionBody>
              </CAccordionItem>
            ))}
          </CAccordion>
        ) : (
          <p>There are no applicable measures for this encounter</p>
        )}
      </div>
    </CCard>
  )
}

export default MIPSCard
